import styles from './TraceLine.module.css';

export interface TraceLineProps {
    /** The request's correlation id — the backend's trace id (`traceIdOf`, `src/lib/api`). */
    readonly traceId: string | undefined;
    readonly testId: string;
}

/**
 * The copyable `Reference <traceId>` line beside an error panel (coding-standards §3.2: error text
 * carries the correlation id, so a user who reports a failure gives support the request to find).
 * Renders nothing when the problem body carried none.
 */
export function TraceLine({ traceId, testId }: TraceLineProps) {
    if (traceId === undefined) {
        return null;
    }
    return (
        <p className={styles.trace} data-testid={testId}>
            Reference <code className={styles.traceId}>{traceId}</code>
        </p>
    );
}
